<template>
  <div>
    <PageHeader :line="false">
      <el-input size="mini" prefix-icon="el-icon-search" placeholder="Search" v-model="searchVal" v-debounce="onSearch"
        clearable @clear="onSearch" />
    </PageHeader>
    <el-table :data="tableData" v-loading="tableLoading" element-loading-text="Loading..." ref="table"
      @sort-change="onSortChange">
      <el-table-column label="No." width="115" prop="No" sortable="custom" />
      <el-table-column label="Type" width="115" prop="Type" sortable="custom" :formatter="formatType" />
      <el-table-column label="Message" min-width="150" prop="Message" sortable="custom">
        <template slot-scope="{row}">
          <template v-if="row.Type === 'text'">
            {{ row.Message }}
          </template>
          <template v-else-if="row.Type === 'link'">
            <el-link class="link" type="primary" @click="goTo(row)">{{ row.Message }}</el-link>
          </template>
          <template v-else-if="row.Type === 'image' || row.Type === 'video' || row.Type === 'voice'">
            <el-link class="link" type="primary" @click="viewMsg(row)">{{ row.Message }}</el-link>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="Created On" width="150" prop="CreatedOn" sortable="custom" />
    </el-table>
    <div class="pagination-wrap">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total" />
    </div>
    <ViewMsgDialog :visible.sync="viewMsgDialogVisible" :data.sync="row" />
  </div>
</template>

<script>
import ViewMsgDialog from './msg/view-msg-dialog'
import * as _ from 'lodash';
export default {
  name: 'PushedContent',
  components: { ViewMsgDialog },
  data() {
    return {
      tableLoading: true,
      searchVal: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: 'CreatedOn',
      orderType: 'descending',
      viewMsgDialogVisible: false,
      row: null
    }
  },
  computed: {
    seId() {
      return this.$route.params.seId
    },
  },
  created() {
    this.getTableData()
  },
  methods: {
    formatType(row, column, cellValue) {
      return _.upperFirst(cellValue)
    },
    onSearch() {
      this.currentPage = 1
      this.getTableData()
    },
    onSortChange(column) {
      this.orderBy = column.prop
      this.orderType = column.order
      this.getTableData()
    },
    getTableData() {
      this.tableLoading = true
      let params = {
        seId: this.seId,
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      }
      this.axios
        .get(`/seDetail/viewMessage`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data
            this.total = data.total
          } else {
            this.$message({
              type: 'error',
              message: msg,
            })
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getTableData()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getTableData()
    },
    viewMsg(row) {
      this.row = row
      this.viewMsgDialogVisible = true
    },
    goTo(data) {
      this.$confirm(`您即将离开礼来远程学术在线，前往第三方网站(${data.Url})。该网站风险未知，请您谨慎甄别。`, {
        title: '第三方网站跳转提醒',
        customClass: 'go-to-confirm-dialog',
        confirmButtonText: '跳转 ',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.open(data.Url, '_blank')
      }).catch(() => { })
    }
  },
}
</script>

<style lang="scss" scoped>
.link {
  padding: 0;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
}
</style>
